import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';

/**
 * GUARD HALL (Караульный зал) — the watchful threshold that holds the STAIR-DOWN to the undercroft.
 *
 * A dim, sparse guardroom built on one clean axial spine: a worn RUNNER laid across the guard line, a
 * fireside FIREPLACE on the north wall as the single bright HERO, and two long guard BENCHES facing the
 * fire (the sit anchors). One ARMOURY accent musters on the west wall — a weapon rack under a tidy pair
 * of shields — and a lone heraldic banner reads over the dungeon descent. The south door-mouths to the
 * MAGE (SW) and DUNGEON (SE) stairs each get ONE wall torch to throw light down into the dark; no other
 * lamps compete with the hearth, so the fire stays the room's brightest beat and the floor breathes.
 *
 * Decluttered: dropped the redundant table-lantern under the hero, the east-wall barrel/cask/shield heap,
 * and the corner braziers — six glow-pools collapsed to three (hearth + two stair torches).
 *
 * Geometry: zone (40,1700) 760×340 → centre (420,1870). Doors: N@x420, E@y1870, and the two SOUTH
 * descents S@x200 (mage) / S@x580 (dungeon) are all kept clear — set-dressing hugs the walls.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;
  const cx = 420;

  // ── Floor: a worn runner laid across the guard line, between the benches (under everything). ──
  place(ctx, kit.runnerRug(art, 380, 96), cx, 1870);

  // ── HERO: the fireside FIREPLACE on the north wall — the room's single brightest warm pool. ──
  place(ctx, kit.fireplace(art, 80), cx, 1760);

  // ── The two guard BENCHES flanking the fire (sit anchors at the brief coords). ──
  place(ctx, kit.pew(art, 120), 200, 1870);
  place(ctx, kit.pew(art, 120), 600, 1870);

  // ── The armoury accent (WEST wall): a weapon rack under a tidy mustered pair of shields. ──
  place(ctx, kit.weaponRack(art), 90, 1820);
  place(ctx, kit.shield(art, 0x8a2f2f), 110, 1730);
  place(ctx, kit.shield(art, 0x2f4a8a), 170, 1730);

  // ── One heraldic banner reading over the dungeon descent. ──
  place(ctx, kit.banner(art, 0x2f4a8a, 84), 580, 1716);

  // ── One wall torch per south door — lighting the two stairs down into the dark. ──
  place(ctx, kit.wallTorch(art), 200, 2010);
  place(ctx, kit.wallTorch(art), 580, 2010);
};

export default decorate;
